import { inr, inrShort } from '../../utils/format';
import { niceMax } from './LineChart';

/** Vertical monthly bars for the account business-metrics modal. */
export default function MonthlyBars({ data, color }) {
  const W = 720, H = 250, padL = 54, padR = 12, padT = 14, padB = 44;
  const n = data.length;
  const gap = (W - padL - padR) / n;
  const bw = gap * 0.6;
  const nice = niceMax(Math.max(1, ...data.map((d) => d.v)));
  const base = H - padB;
  const y = (v) => padT + (base - padT) * (1 - v / nice);

  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" height={H}>
      {[0, 1, 2, 3, 4].map((t) => {
        const gv = (nice * t) / 4;
        const gy = y(gv);
        return (
          <g key={t}>
            <line className="gl" x1={padL} y1={gy} x2={W - padR} y2={gy} />
            <text className="ax" x={padL - 8} y={gy + 3} textAnchor="end">{inrShort(gv)}</text>
          </g>
        );
      })}
      {data.map((d, i) => {
        const x = padL + i * gap + (gap - bw) / 2;
        return (
          <g key={d.label}>
            <rect
              x={x} y={y(d.v)} width={bw} height={Math.max(1, base - y(d.v))} rx={3} fill={color}
              data-t={`${d.label}||${inr(d.v)}`}
            />
            <text className="ax" x={x + bw / 2} y={H - 16} textAnchor="middle">{d.label}</text>
          </g>
        );
      })}
    </svg>
  );
}
